"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCookieDefinitions = void 0;
const __1 = require("../..");
const buildCookieDefinitions = ({ language_code, route_id, }) => {
    const cookies = [];
    cookies.push({
        key: __1.LANGUAGE_COOKIE_KEY,
        value: language_code,
        options: __1.DEFAULT_COOKIE_OPTIONS,
    });
    if (route_id) {
        cookies.push({
            key: __1.ROUTE_COOKIE_KEY,
            value: route_id,
            // Use persistent cookies for route id. We need to do this to avoid presumed issues with
            // sessions being load on reload of cached pages for browsers such as iOS Safari.
            //
            // Making this cookie as durable as our other meristem cookies as the two must be kept
            // in sync for either to work.
            //
            // The cookie will retain whatever the last value set for the user was, but this is considered
            // generally safe as nearly all support entry points explicitly set the route.
            options: __1.DEFAULT_COOKIE_OPTIONS,
        });
    }
    return cookies;
};
exports.buildCookieDefinitions = buildCookieDefinitions;
//# sourceMappingURL=index.js.map